import { render, staticRenderFns } from "./MFormImages.vue?vue&type=template&id=53e048c3&scoped=true&"
import script from "./MFormImages.vue?vue&type=script&lang=js&"
export * from "./MFormImages.vue?vue&type=script&lang=js&"
import style0 from "./MFormImages.vue?vue&type=style&index=0&id=53e048c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e048c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VFileInput,VIcon,VImg,VLayout,VTooltip})
